import { Option, Select } from "@mui/joy";
import axios from "axios";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";

import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ClearButton from "common/components/Button/ClearButton";
import { useAuth } from "common/hooks/useAuth";
import { BACKEND_URL_CONFIG } from "config";
import { ERRORS } from "errors";
import { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import styles from "./NewBlockFromSavedParamsForm.module.css";

const customSelectStyle = {
  "--Select-placeholderOpacity": "unset",
  backgroundColor: "white",
  fontSize: "13px",
  fontFamily: "inherit",
};

export default function NewBlockFromSavedParamsForm({
  block,
  formId,
  setFormData,
  subBlockType,
  setIsSubmitting,
  defaultBlockDisplayName,
}) {
  // States
  const [loading, setLoading] = useState(false);
  const [availableSavedParameters, setAvailableSavedParameters] = useState([]);

  // Contexts
  const { currentUser } = useAuth();

  const {
    register,
    handleSubmit,
    formState: { isSubmitting },
    control,
  } = useForm({
    defaultValues: {
      blockDisplayName: block ? block.name : defaultBlockDisplayName,
      saved_parameters_id: block ? block.parameters.saved_parameters_id : null,
    },
  });

  useEffect(() => {
    fetchAvailableSavedParameters();
  }, []);

  useEffect(() => {
    setIsSubmitting(isSubmitting);
  }, [isSubmitting]);

  const onSubmit = (data) => {
    const submittedData = {
      blockDisplayName: data.blockDisplayName,
      saved_parameters_id: data.saved_parameters_id,
    };

    setFormData(submittedData);
  };

  const fetchAvailableSavedParameters = async () => {
    setLoading(true);
    const url = BACKEND_URL_CONFIG.getParametersFilesListBySubtype.replace(
      "{subtype}",
      subBlockType
    );
    try {
      const response = await axios.get(url, {
        headers: {
          "X-KEY": currentUser.accessToken,
        },
      });
      if (response.status === 200) {
        setAvailableSavedParameters(response.data);
      }
    } catch (error) {
      toast.error(ERRORS.error_159);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form
      id={formId}
      onSubmit={handleSubmit(onSubmit)}
      className={styles.container}
    >
      <div className={styles["field-container"]}>
        <label className={styles.label}>Nom du bloc</label>
        <input
          {...register("blockDisplayName", { required: true })}
          type="text"
          required={true}
          className={styles["text-input"]}
          placeholder="Saisir le nom de votre bloc"
        />
      </div>
      <div className={styles["field-container"]}>
        <label className={styles.label}>Choix des paramètres enregistrés</label>
        <Controller
          name="saved_parameters_id"
          control={control}
          rules={{ required: true }}
          render={({ field }) => (
            <Select
              {...field}
              placeholder="Choisir vos paramètres enregistrés..."
              style={customSelectStyle}
              disabled={loading}
              onChange={(e, newValue) => {
                field.onChange(newValue);
              }}
              {...(field.value && {
                endDecorator: (
                  <ClearButton
                    onClick={() => {
                      field.onChange(null);
                    }}
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </ClearButton>
                ),
                indicator: null,
              })}
            >
              {availableSavedParameters?.map((savedParameter) => (
                <Option key={savedParameter.id} value={savedParameter.id}>
                  {savedParameter.name}
                </Option>
              ))}
            </Select>
          )}
        />
      </div>
    </form>
  );
}
